/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export const InputTypes = {
  Button: 'button',
  Checkbox: 'checkbox',
  Color: 'color',
  Date: 'date',
  DateTimeLocal: 'datetime-local',
  Email: 'email',
  File: 'file',
  Hidden: 'hidden',
  Image: 'image',
  Month: 'month',
  Number: 'number',
  Password: 'password',
  Radio: 'radio',
  Range: 'range',
  Reset: 'reset',
  Search: 'search',
  Submit: 'submit',
  Tel: 'tel',
  Text: 'text',
  Time: 'time',
  Url: 'url',
  Week: 'week',
};
